export const yupErrors = (err: unknown): string | undefined =>
  // oxlint-disable-next-line typescript/no-unsafe-type-assertion
  ((err as { errors?: string[] })?.errors || []).join("\n");
